import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class ControlFormsService {
  public itemValueRichText = new BehaviorSubject<boolean>(true);
  public itemValueTime = new BehaviorSubject<boolean>(true);
  public itemValuePickList = new BehaviorSubject<boolean>(true);
  public itemValueDataPicker = new BehaviorSubject<boolean>(true);
  public itemValueImagePicker = new BehaviorSubject<boolean>(true);

  set theItemRichText(value: boolean) {
    this.itemValueRichText.next(value);
    localStorage.setItem("richText", JSON.stringify(value) );
  }

  get theItemRichText() {
    return JSON.parse( localStorage.getItem("richText") );
  }

  set theItemTime(value: boolean) {
    this.itemValueTime.next(value);
    localStorage.setItem("time", JSON.stringify(value) );
  }

  get theItemTime() {
    return JSON.parse( localStorage.getItem("time") );
  }

  set theItemPickList(value: boolean) {
    this.itemValuePickList.next(value);
    localStorage.setItem("pickList", JSON.stringify(value) );
  }

  get theItemPickList() {
    return JSON.parse( localStorage.getItem("pickList") );
  }

  set theItemDataPicker(value: boolean) {
    this.itemValueDataPicker.next(value);
    localStorage.setItem("dataPicker", JSON.stringify(value) );
  }

  get theItemDataPicker() {
    return JSON.parse( localStorage.getItem("dataPicker") );
  }

  set theItemImagePicker(value: boolean) {
    this.itemValueImagePicker.next(value);
    localStorage.setItem("imagePicker", JSON.stringify(value) );
  }

  get theItemImagePicker() {
    return JSON.parse( localStorage.getItem("imagePicker") );
  }


}
